export const PRESS_CENTER_URL = 'https://company.vinted.com'
